export default __webpack_public_path__ + "static/media/561.0aeabc5b.png";